import { render } from "./ListMessages.component.vue?vue&type=template&id=96b1389e&ts=true"
import script from "./ListMessages.component.vue?vue&type=script&lang=ts"
export * from "./ListMessages.component.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/SMSFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__